export default __webpack_public_path__ + "static/media/panini.7595e740.jpg";